import { render, staticRenderFns } from "./AppSpecifications.vue?vue&type=template&id=1bef41b6&scoped=true&"
import script from "./AppSpecifications.vue?vue&type=script&lang=js&"
export * from "./AppSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./AppSpecifications.vue?vue&type=style&index=0&id=1bef41b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef41b6",
  null
  
)

export default component.exports